import { applicationAPI } from '../../api';
import { AppThunk } from 'store';
import { batch } from 'react-redux';
import { getResponseError } from 'common/utils';

import { LOADING_STATUS } from 'shared/constants';

import { applicationActions } from '../reducer';

const {
  setErrorNotice,
  setFeatureFlags,
  setFeatureFlagsLoadingStatus
} = applicationActions;

export const getFeatureFlags = (): AppThunk => async (dispatch) => {
  try {
    dispatch(setFeatureFlagsLoadingStatus(LOADING_STATUS.load));

    const { data: { featureFlags } } = await applicationAPI.getFeatureFlags();

    batch(() => {
      dispatch(setFeatureFlags(featureFlags));
      dispatch(setFeatureFlagsLoadingStatus(LOADING_STATUS.done));
    });
  } catch (e) {
    const error = await getResponseError(e);
    batch(() => {
      dispatch(setErrorNotice(error));
      dispatch(setFeatureFlagsLoadingStatus(LOADING_STATUS.error));
    });
  }
};
